import React from 'react'
import { Search as SearchIcon } from 'react-feather'

import {
  Card,
  Typography,
  Box,
  makeStyles,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@material-ui/core'
import { ListCompanies } from '../'

import styles from './styles'

const useStyles = makeStyles(styles)

const CardCompanies = ({
  usersCompanies,
  isLoading,
  onLoadMore,
  onBeforeSelect,
  searchInput,
  onSearch,
}) => {
  const classes = useStyles()

  return (
    <>
      <Box mb={2} className={classes.wrapper}>
        <Box mb={2}>
          <Typography variant="h4">Selecione a organização</Typography>
        </Box>

        <Card className={classes.root}>
          <Box mx={2} mt={2}>
            <TextField
              fullWidth
              placeholder="Pesquise pelo nome ou documento da organização"
              value={searchInput}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon size={20} />
                  </InputAdornment>
                ),
              }}
              variant="outlined"
              autoFocus
              onChange={(e) => onSearch(e.target.value)}
            />
          </Box>
          <Box
            mt={2}
            style={{
              flex: 1,
              minHeight: 0,
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            {isLoading && usersCompanies.length === 0 && (
              <Box display="flex" justifyContent="center" py={4}>
                <CircularProgress />
              </Box>
            )}
            {usersCompanies.length > 0 && (
              <>
                <ListCompanies
                  usersCompanies={usersCompanies}
                  onLoadMore={onLoadMore}
                  isLoadingMore={isLoading}
                  onBeforeSelect={onBeforeSelect}
                />
                <Box
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: '48px',
                    background:
                      'linear-gradient(to bottom, transparent, rgba(255,255,255,0.95))',
                    pointerEvents: 'none',
                  }}
                />
              </>
            )}
          </Box>
        </Card>
      </Box>
    </>
  )
}

export default CardCompanies
